function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var Iloading = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    notChangeable: true,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "8",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0V1.45455C11.6149 1.45456 14.5454 4.38505 14.5454 8C14.5454 11.615 11.6149 14.5455 7.99998 14.5455C4.38503 14.5455 1.45453 11.615 1.45453 8L0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62921 8.00272L10.5372 6.09472C10.711 5.92094 10.711 5.64005 10.5372 5.46627C10.3634 5.29249 10.0825 5.29249 9.90876 5.46627L8.00076 7.37427L6.09276 5.46627C5.91898 5.29249 5.6381 5.29249 5.46432 5.46627C5.29054 5.64005 5.29054 5.92094 5.46432 6.09472L7.37232 8.00272L5.46432 9.91072C5.29054 10.0845 5.29054 10.3654 5.46432 10.5392C5.55098 10.6258 5.66476 10.6694 5.77854 10.6694C5.89232 10.6694 6.0061 10.6258 6.09276 10.5392L8.00076 8.63116L9.90876 10.5392C9.99543 10.6258 10.1092 10.6694 10.223 10.6694C10.3368 10.6694 10.4505 10.6258 10.5372 10.5392C10.711 10.3654 10.711 10.0845 10.5372 9.91072L8.62921 8.00272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "5",
    y: "5",
    width: "6",
    height: "6"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62921 8.00272L10.5372 6.09472C10.711 5.92094 10.711 5.64005 10.5372 5.46627C10.3634 5.29249 10.0825 5.29249 9.90876 5.46627L8.00076 7.37427L6.09276 5.46627C5.91898 5.29249 5.6381 5.29249 5.46432 5.46627C5.29054 5.64005 5.29054 5.92094 5.46432 6.09472L7.37232 8.00272L5.46432 9.91072C5.29054 10.0845 5.29054 10.3654 5.46432 10.5392C5.55098 10.6258 5.66476 10.6694 5.77854 10.6694C5.89232 10.6694 6.0061 10.6258 6.09276 10.5392L8.00076 8.63116L9.90876 10.5392C9.99543 10.6258 10.1092 10.6694 10.223 10.6694C10.3368 10.6694 10.4505 10.6258 10.5372 10.5392C10.711 10.3654 10.711 10.0845 10.5372 9.91072L8.62921 8.00272Z",
    fill: "white"
  })));
});